<template>
  <div class="footer">
    <p>As the UK’s largest student accommodation provider, Unite Students has 30 years’ experience of creating a home for success for young people. That means providing a safe and secure home where students feel supported while making the big ‘Leap’ to university life.</p>
    <p>Our insight reports have identified a significant gap in teenagers’ expectations of what life will be like living away from home. Both UCAS and Unite Students agree that the better equipped a young person is for those changes, the easier they will meet the challenges involved.</p>
  </div>
</template>

<script>
export default {
  name: 'homeFooter'
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/HomeFooter.vue